export function getReportFileName(title: string, format: string, selectedCompany?: string): string {
  let fileName = title

  if (selectedCompany) fileName += ` - ${selectedCompany}`

  return fileName + '.' + format
}
